import {Injectable} from '@angular/core';

@Injectable()
export class IsSingletonGuard {
  checkIfSingleton(parentModule: any, moduleName: string): boolean {
    if (parentModule) {
      throw new Error(`${moduleName} has already been loaded. Import Core modules in the AppModule only.`);
    }
    return true;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/core/guards/is-singleton.guard.ts